export enum ACTIONS {
  TOGGLE_SCOREBOARD = 'TOGGLE_SCOREBOARD',
}

export interface IScoreboardStatusState {
  isScoreboardOpen: boolean;
}

export const TOTAL_SCOREBOARD_ROUNDS = 60;
